import fetchJsonFromRpgLogsApi from './fetchJsonFromRpgLogsApi';
import getGameSlugs from './getGameSlugs';

export type BuildsZonePageSlugsViewModel = {
  gameSlug: string;
  rankingsSlug: string;
  zoneTypeSlug: string;
  difficultySlug: string;
  encounterSlug: string;
  affixesSlug?: string | null;
};

async function getBuildsZonePageSlugs(): Promise<
  BuildsZonePageSlugsViewModel[]
> {
  const gameSlugs = await getGameSlugs();

  return (
    await Promise.all(
      gameSlugs.map(async (gameSlug) => {
        const data = await fetchJsonFromRpgLogsApi({
          query: `query {
  viewModels {
    buildsZonePageSlugs
  }
}`,
          gameSlug,
        });

        return data.viewModels.buildsZonePageSlugs;
      }),
    )
  ).reduce((x, y) => x.concat(y), []);
}

export default getBuildsZonePageSlugs;
